const enTranslation = {
    "login": "Login",
    "login_failed": "Login Failed",
    "email": "Email",
    "password": "Password",
    "create_account": "Create Account",
    "forgot_password": "Forgot Password",
    "reset_password": "Reset Password",
    "reset_password_error": "Reset Password Error",
    "send_reset_link": "Send Reset Link",
    "reset_token": "Reset Token",
    "new_password": "New Password",
    "registration_failed": "Registration Failed",
    "sign_up": "Sign Up",
    "username": "Username",
    "settings": "Settings",
    "general": "General",
    "avatar": "Avatar",
    "dark_mode": "Dark Mode",
    "language": "Language",
    "unblock_posts": "Unblock Posts",
    "advanced": "Advanced",
    "delete_account": "Delete Account",
    "delete": "Delete",
    "change_avatar": "Change Avatar",
    "enter_new_username": "Enter your new username:",
    "enter_new_email": "Enter your new email:",
    "enter_new_password": "Enter your new password:",
    "select_language": "Select Language",
    "back": "Back",
    "change": "Change",
    "no_blocked_posts": "No blocked posts.",
    "unblock": "Unblock",
    "enter_password_to_delete": "Enter the current password to delete your account:",
    "all": "All",
    "friends": "Friends",
    "favorite_games": "Favorite Games",
    "games": "Games",
    "more_badges": "More Badges",
    "no_in_progress_badges": "No in-progress badges",
    "all_earned_badges": "All Earned Badges",
    "close": "Close",
    "style_guide": "Style Guide",
    "accept": "Accept",
    "reject": "Reject",
    "search_website": "Search the Website",
    "go": "GO!",
    "create+": "Create +",
    "profile": "Profile",
    "logout": "Log out",
    "about_us": "About Us",
    "notifications": "Notifications",
    "friend_requests": "Friend Requests",
    "badges": "Badges",
    "no_new_requests": "No new requests",
    "no_new_badge_alerts": "No new badge alerts",
    "post_type": "Post Type",
    "other": "Other",
    "clear": "Clear",
    "genre": "Genre",
    "go_to_page": "Go to Page",
    "loading_posts": "Loading posts...",
    "loading_friends": "Loading friends...",
    "no_posts_yet": "No one has posted yet. Be the first!",
    "loading_more_posts": "Loading more posts...",
    "search_results_for": "Search Results for: ",
    "no_posts_found": "No posts found.",
    "no_users_found": "No users found.",
    "no_games_found": "No games found.",
    "view_profile": "View Profile",
    "trending_games": "Trending Games",
    "post_not_found": "Post not found",
    "post_blocked": "This post is blocked.",
    "visibility": "Visibility",
    "friends_only": "Friends Only",
    "public": "Public",
    "save": "Save",
    "my_connections": "My Connections",
    "no_connections_found": "No connections found. Try sending a friend request.",
    "connection_already_exists": "Connection already exists or is pending.",
    "error_sending_request": "Error sending request.",
    "find_a_friend": "Find a Friend!",
    "connect": "Connect",
    "cancel": "Cancel",
    "message": "Message",
    "block": "Block",
    "unfriend": "Unfriend",
    "rejected": "Rejected",
    "canceled": "Canceled",
    "please_log_in": "Please Log In...",
    "loading": "Loading...",
    "edited": "Edited",
    "no_choices_available": "No choices available",
    "comments": "Comments",
    "block_post_confirmation": "Are you sure you want to block this post?",
    "yes": "Yes",
    "no": "No",
    "edit": "Edit",
    "edit_poll_choices": "Edit Poll Choices:",
    "remove": "Remove",
    "add_choice": "Add Choice",
    "comment": "Comment",
    "submit": "Submit",
    "post": "Post",
    "poll": "Poll",
    "create_post": "Create a Post",
    "title": "Title",
    "title_placeholder": "Enter post title...",
    "game": "Game",
    "search_game_placeholder": "Search for Game...",
    "no_results_found": "No results found",
    "body": "Body",
    "body_placeholder": "Enter your post content here...",
    "tags": "Tags",
    "hide_tags": "Hide Tags",
    "select_tags": "Select Tags",
    "title_body_empty_error": "Title and body cannot be empty.",
    "post_creation_error": "Error creating post! Please try again.",
    "create": "Create",
    "create_poll": "Create a Poll",
    "poll_duration": "Poll Duration",
    "poll_options": "Poll Options",
    "add_option": "Add Option",
    "posts": "Posts",
    "users": "Users",
    "view_all_filters": "View All Filters",
    "profile_image_alt": "Profile Image",
    "bio_placeholder": "Type in your Bio!",
    "name": "Name",
    "overview": "Overview",
    "see_more": "See More",
    "add_friend": "Add Friend",
    "untitled_post": "Untitled Post",
    "unknown_date": "Unknown Date",
    "loading_profile": "Loading profile...",
    "completed": "Completed",
    "in_progress": "In Progress",
    "badge_tiers": "Badge Tiers",
    "rookie": "Rookie",
    "bronze": "Bronze",
    "silver": "Silver",
    "gold": "Gold",
    "platinum": "Platinum",
    "earned": "Earned",
    "favorite_games_saved": "Favorite games saved",
    "select_favorite_games": "Select up to 5 favorite games",
    "confirm": "Confirm",
    "messaging:": "Messaging: ",
    "write_message": "Write message",
    "send": "Send",
    "sort_posts_by": "Sort Posts By:",
    "filter_posts_by_tags": "Filter Posts By Tags:",
};

export default enTranslation;
